<template>
    <div class="photo-editor">
      <img  v-no-right-click ref="photo" :src="props.image" :alt="t('kasolcum.editor.photo_alt')" />
    </div>
  </template>
  
  <script setup>
  /* global defineProps */
  import { ref, onMounted, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import interact from 'interactjs'

  const { t } = useI18n()
  
  const props = defineProps({
    image: {
      type: String,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  })
  
  const photo = ref(null)
  
  onMounted(() => {
  const el = photo.value

  photo.value.dataset.x = 0
  photo.value.dataset.y = 0
  photo.value.dataset.scale = 1
  photo.value.dataset.rotation = 0

  let startScale = 1
  let startRotation = 0
  let initialGestureAngle = 0
  let activePointers = []

  function updateTransform() {
    const x = el.dataset.x
    const y = el.dataset.y
    const scale = el.dataset.scale
    const rotation = el.dataset.rotation
    el.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotation}deg)`
  }

  let interactable = createInteractable()

  function createInteractable() {
    return interact(el)
      .draggable({
        enabled: !props.locked,
        listeners: {
          move(event) {
            const x = parseFloat(el.dataset.x) + event.dx
            const y = parseFloat(el.dataset.y) + event.dy
            el.dataset.x = x
            el.dataset.y = y
            updateTransform()
          }
        }
      })
      .gesturable({
        enabled: !props.locked,
        listeners: {
          start(event) {
            startScale = parseFloat(el.dataset.scale)
            startRotation = parseFloat(el.dataset.rotation)
            initialGestureAngle = event.angle
          },
          move(event) {
            const newScale = startScale * event.scale
            const newRotation = startRotation + (event.angle - initialGestureAngle)
            el.dataset.scale = newScale
            el.dataset.rotation = newRotation
            updateTransform()
          }
        }
      })
  }

  el.addEventListener('pointerdown', (e) => {
    if (!activePointers.includes(e.pointerId)) {
      activePointers.push(e.pointerId)
    }

    if (activePointers.length === 2) {
      interactable.unset()
      interactable = createInteractable()
    }
  })

  el.addEventListener('pointerup', (e) => {
    activePointers = activePointers.filter(id => id !== e.pointerId)
  })

  el.addEventListener('pointercancel', (e) => {
    activePointers = activePointers.filter(id => id !== e.pointerId)
  })

  watch(() => props.locked, (newVal) => {
    interactable.draggable({ enabled: !newVal })
    interactable.gesturable({ enabled: !newVal })
  })
})

  </script>
  
  <style scoped>
  .photo-editor {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .photo-editor img {
    max-width: 100%;
    display: block;
    touch-action: none;
    user-select: none;
  }
  </style>
  